<template>
  <div>
    <h1 class="mb-2 mt-2">Product breakdowns</h1>

    <b-row class="match-height">
      <b-col
        v-for="(distribution, index) in distributions"
        :key="`${distribution.title}-${index}`"
        cols="4"
      >
        <leaderboard-comparison
          :key="`leaderboard-${distribution.title}-${distribution.data.length}`"
          :title="distribution.title"
          :subtitle="distribution.subtitle"
          :data="distribution.data"
          :loading="loading"
          :use-icons="distribution.useIcons"
          :hide-logos="distribution.hideLogos"
          single-column
          hide-charts
          @item-clicked="handleItemClick(distribution.title, $event)"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
} from 'bootstrap-vue'
import LeaderboardComparison from '@/views/ecommerce/LeaderboardComparison.vue'

export default {
  components: {
    BRow,
    BCol,
    LeaderboardComparison,
  },
  props: {
    distributions: {
      type: Array,
      default: () => [],
      // Expected format:
      // [
      //   { title: 'Counterparties', subtitle: 'Distribution by counterparty', data: [], hideLogos: true },
      //   { title: 'Underlying', subtitle: 'Distribution by underlying', data: [], hideLogos: true },
      //   { title: 'Product Type', subtitle: 'Distribution by type', data: [], hideLogos: false }
      // ]
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleItemClick(categoryTitle, item) {
      // The item already has the thisid property from LeaderboardComparison
      if (item.thisid === undefined) return

      const categoryLower = categoryTitle.toLowerCase()

      // Route to the appropriate details page based on category
      if (categoryLower === 'counterparty' || categoryLower === 'counterparties') {
        this.$router.push({
          name: 'counterparty-details',
          params: { cid: item.thisid },
        })
      } else if (categoryLower === 'underlying' || categoryLower === 'underlyings') {
        this.$router.push({
          name: 'underlying-details',
          params: { uid: item.thisid },
        })
      } else if (categoryLower === 'product type' || categoryLower === 'product types') {
        this.$router.push({
          name: 'product-type-details',
          params: { ptid: item.thisid },
        })
      } else if (categoryLower === 'provider' || categoryLower === 'providers') {
        this.$router.push({
          name: 'content',
          params: { pid: item.thisid },
        })
      }
    },
  },
}
</script>
